const docs = {};

export default docs;
